import { TherapeuticArea } from '@lib/types/TherapeuticArea'
import {
  ALTO_MDD_PHASE_2,
  ALZHEIMER_TEST_TRIAL,
  CYBIN_GAD_PHASE_2,
  ENGRAIL_GAD_PHASE_2,
  MINDMED_GAD_PHASE_3,
  MINDMED_GAD_PHASE_3_SISTER_TRIAL,
  PARKINSON_TEST_TRIAL,
  RECOGNIFY_SCHIZ_PHASE_2,
  SANOFI_AQUA_PHASE_3,
  SANOFI_COAST_2_PHASE_3,
  SANOFI_MS_PHASE_3_1,
  SANOFI_MS_PHASE_3_2,
  VISTAGEN_PALISADE_3,
  VISTAGEN_PALISADE_4,
} from '@modules/trials/constants/trials'

type Medication = { displayName: string; value: string }

type MedicationByTrial = {
  medications: Medication[]
  nctIds: string[]
}
type MedicationByCondition = {
  conditions: string[]
  medications: Medication[]
  therapeuticAreas: string[]
}

// Followed list in https://docs.google.com/spreadsheets/d/1BdRKefz_lhRhctVxVNcusNVvIw7fupgM8q-0ZGId088/edit?gid=268586133#gid=268586133
export const PopularMedicationsByNctId: MedicationByTrial[] = [
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Bupropion (Wellbutrin)', value: 'Bupropion' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
    ],
    // Major Depressive Disorder
    nctIds: [ALTO_MDD_PHASE_2.nctId],
  },
  {
    medications: [
      { displayName: 'Aducanumab (Aduhelm)', value: 'Aducanumab' },
      { displayName: 'Lecanemab (Leqembi)', value: 'Lecanemab' },
      { displayName: 'Donepezil (Aricept)', value: 'Donepezil' },
      { displayName: 'Rivastigmine (Exelon)', value: 'Rivastigmine' },
      { displayName: 'Galantamine (Razadyne)', value: 'Galantamine' },
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Memantine (Namenda)', value: 'Memantine' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
      { displayName: 'Oxazepam (Serax)', value: 'Oxazepam' },
      { displayName: 'Buspirone (Buspar)', value: 'Buspirone' },
      { displayName: 'Valproic Acid (Depakote)', value: 'Valproic Acid' },
      { displayName: 'Carbamazepine (Tegretol)', value: 'Carbamazepine' },
    ],
    // Alzheimer's Disease
    nctIds: [ALZHEIMER_TEST_TRIAL.nctId],
  },
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Buspirone (BuSpar)', value: 'Buspirone' },
      { displayName: 'Alprazolam (Xanax)', value: 'Alprazolam' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
    ],
    // Generalized Anxiety Disorder
    nctIds: [
      ENGRAIL_GAD_PHASE_2.nctId,
      CYBIN_GAD_PHASE_2.nctId,
      MINDMED_GAD_PHASE_3.nctId,
      MINDMED_GAD_PHASE_3_SISTER_TRIAL.nctId,
    ],
  },
  {
    medications: [
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Olanzapine (Zyprexa)', value: 'Olanzapine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Paliperidone (Invega)', value: 'Paliperidone' },
    ],
    // Schizophrenia
    nctIds: [RECOGNIFY_SCHIZ_PHASE_2.nctId],
  },
  {
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Clonazepam (Klonopin)', value: 'Clonazepam' },
      { displayName: 'Alprazolam (Xanax)', value: 'Alprazolam' },
      { displayName: 'Propranolol (Inderal)', value: 'Propranolol' },
    ],
    // Social Anxiety
    nctIds: [VISTAGEN_PALISADE_3.nctId, VISTAGEN_PALISADE_4.nctId],
  },
  {
    medications: [
      { displayName: 'Dupilumab (Dupixent)', value: 'Dupilumab' },
      { displayName: 'Tralokinumab (Adbry)', value: 'Tralokinumab' },
      { displayName: 'Upadacitinib (Rinvoq)', value: 'Upadacitinib' },
      { displayName: 'Abrocitinib (Cibinqo)', value: 'Abrocitinib' },
      { displayName: 'Hydrocortisone', value: 'Hydrocortisone' },
      { displayName: 'Betamethasone', value: 'Betamethasone' },
      { displayName: 'Clobetasol', value: 'Clobetasol' },
      { displayName: 'Tacrolimus (Protopic)', value: 'Tacrolimus' },
      { displayName: 'Pimecrolimus (Elidel)', value: 'Pimecrolimus' },
      { displayName: 'Crisaborole (Eucrisa)', value: 'Crisaborole' },
    ],
    // Atopic Dermatitis
    nctIds: [SANOFI_AQUA_PHASE_3.nctId, SANOFI_COAST_2_PHASE_3.nctId],
  },
  {
    medications: [
      { displayName: 'Lemtrada (Alemtuzumab)', value: 'Alemtuzumab' },
      { displayName: 'Mavenclad (Cladribine)', value: 'Cladribine' },
      { displayName: 'Aubagio (Teriflunomide)', value: 'Teriflunomide' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Sandimmune (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Novantrone (Mitoxantrone)', value: 'Mitoxantrone' },
      { displayName: 'Cytoxan (Cyclophosphamide)', value: 'Cyclophosphamide' },
      { displayName: 'Gilenya (Fingolimod)', value: 'Fingolimod' },
      { displayName: 'Imuran (Azathioprine)', value: 'Azathioprine' },
    ],
    // Multiple Sclerosis
    nctIds: [SANOFI_MS_PHASE_3_1.nctId, SANOFI_MS_PHASE_3_2.nctId],
  },
  {
    medications: [
      { displayName: 'Apokyn (Apomorphine)', value: 'Apomorphine' },
      { displayName: 'Azilect (Rasagiline)', value: 'Rasagiline' },
      { displayName: 'Eldepryl (Selegiline)', value: 'Selegiline' },
      { displayName: 'Insulin (Insulin lispro)', value: 'Insulin lispro' },
      { displayName: 'Levodopa', value: 'Levodopa' },
      { displayName: 'Mirapex (Pramipexole)', value: 'Pramipexole' },
      { displayName: 'Neupro (Rotigotine)', value: 'Rotigotine' },
      { displayName: 'Ozempic (Semaglutide)', value: 'Semaglutide' },
      { displayName: 'Requip (Ropinirole)', value: 'Ropinirole' },
      { displayName: 'Victoza (Liraglutide)', value: 'Liraglutide' },
      { displayName: 'Xadago (Safinamide)', value: 'Safinamide' },
      { displayName: 'Zelapar (Selegiline)', value: 'Selegiline' },
    ],
    // Parkinson's Disease
    nctIds: [PARKINSON_TEST_TRIAL.nctId],
  },
]

// created using ChatGPT asking "What are the most popular medications for XXX"
export const PopularMedicationsByCondition: MedicationByCondition[] = [
  {
    conditions: ["alzheimer's disease"],
    medications: [
      { displayName: 'Aducanumab (Aduhelm)', value: 'Aducanumab' },
      { displayName: 'Lecanemab (Leqembi)', value: 'Lecanemab' },
      { displayName: 'Donepezil (Aricept)', value: 'Donepezil' },
      { displayName: 'Rivastigmine (Exelon)', value: 'Rivastigmine' },
      { displayName: 'Galantamine (Razadyne)', value: 'Galantamine' },
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Memantine (Namenda)', value: 'Memantine' },
      { displayName: 'Lorazepam (Ativan)', value: 'Lorazepam' },
      { displayName: 'Oxazepam (Serax)', value: 'Oxazepam' },
      { displayName: 'Buspirone (Buspar)', value: 'Buspirone' },
      { displayName: 'Valproic Acid (Depakote)', value: 'Valproic Acid' },
      { displayName: 'Carbamazepine (Tegretol)', value: 'Carbamazepine' },
    ],
    therapeuticAreas: [TherapeuticArea.Neurology],
  },
  {
    conditions: ['major depressive disorder'],
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Citalopram (Celexa)', value: 'Citalopram' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Paroxetine (Paxil)', value: 'Paroxetine' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Desvenlafaxine (Pristiq)', value: 'Desvenlafaxine' },
      { displayName: 'Duloxetine (Cymbalta)', value: 'Duloxetine' },
      { displayName: 'Milnacipran (Savella)', value: 'Milnacipran' },
      { displayName: 'Levomilnacipran (Fetzima)', value: 'Levomilnacipran' },
    ],
    therapeuticAreas: [TherapeuticArea.Psychiatry],
  },
  {
    conditions: ['schizophrenia'],
    medications: [
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Olanzapine (Zyprexa)', value: 'Olanzapine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Clozapine (Clozaril or Versacloz)', value: 'Clozapine' },
      { displayName: 'Haloperidol (Haldol)', value: 'Haloperidol' },
      { displayName: 'Chlorpromazine (Thorazine)', value: 'Chlorpromazine' },
      { displayName: 'Lurasidone (Latuda)', value: 'Lurasidone' },
      { displayName: 'Ziprasidone (Geodon)', value: 'Ziprasidone' },
      { displayName: 'Paliperidone (Invega)', value: 'Paliperidone' },
    ],
    therapeuticAreas: [TherapeuticArea.Psychiatry],
  },
  {
    conditions: ['atopic dermatitis'],
    medications: [
      { displayName: 'Dupilumab (Dupixent)', value: 'Dupilumab' },
      { displayName: 'Tralokinumab (Adbry)', value: 'Tralokinumab' },
      { displayName: 'Upadacitinib (Rinvoq)', value: 'Upadacitinib' },
      { displayName: 'Abrocitinib (Cibinqo)', value: 'Abrocitinib' },
      { displayName: 'Hydrocortisone', value: 'Hydrocortisone' },
      { displayName: 'Betamethasone', value: 'Betamethasone' },
      { displayName: 'Clobetasol', value: 'Clobetasol' },
      { displayName: 'Tacrolimus (Protopic)', value: 'Tacrolimus' },
      { displayName: 'Pimecrolimus (Elidel)', value: 'Pimecrolimus' },
      { displayName: 'Crisaborole (Eucrisa)', value: 'Crisaborole' },
    ],
    therapeuticAreas: [TherapeuticArea.Dermatology],
  },
  {
    conditions: ['multiple sclerosis'],
    medications: [
      { displayName: 'Lemtrada (Alemtuzumab)', value: 'Alemtuzumab' },
      { displayName: 'Mavenclad (Cladribine)', value: 'Cladribine' },
      { displayName: 'Aubagio (Teriflunomide)', value: 'Teriflunomide' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Sandimmune (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Novantrone (Mitoxantrone)', value: 'Mitoxantrone' },
      { displayName: 'Cytoxan (Cyclophosphamide)', value: 'Cyclophosphamide' },
      { displayName: 'Gilenya (Fingolimod)', value: 'Fingolimod' },
      { displayName: 'Imuran (Azathioprine)', value: 'Azathioprine' },
    ],
    therapeuticAreas: [TherapeuticArea.Neurology],
  },
  {
    conditions: ['asthma'],
    medications: [
      { displayName: 'Deltasone (Prednisone)', value: 'Prednisone' },
      {
        displayName: 'Medrol (Methylprednisolone)',
        value: 'Methylprednisolone',
      },
      { displayName: 'Orapred ODT (Prednisolone)', value: 'Prednisolone' },
      {
        displayName: 'Flovent HFA (Fluticasone Propionate)',
        value: 'Fluticasone Propionate',
      },
      { displayName: 'Pulmicort Flexhaler (Budesonide)', value: 'Budesonide' },
      {
        displayName: 'Qvar RediHaler (Beclomethasone Dipropionate)',
        value: 'Beclomethasone Dipropionate',
      },
      {
        displayName: 'Arnuity Ellipta (Fluticasone Furoate)',
        value: 'Fluticasone Furoate',
      },
      { displayName: 'Symbicort (Budesonide)', value: 'Budesonide' },
    ],
    therapeuticAreas: [TherapeuticArea.Respirology],
  },
  {
    conditions: ['epilepsy'],
    medications: [
      { displayName: 'Lamictal (Lamotrigine)', value: 'Lamotrigine' },
      { displayName: 'Topamax (Topiramate)', value: 'Topiramate' },
      { displayName: 'Keppra (Levetiracetam)', value: 'Levetiracetam' },
      { displayName: 'Depakote (Valproic Acid)', value: 'Valproic Acid' },
      { displayName: 'Trileptal (Oxcarbazepine)', value: 'Oxcarbazepine' },
      { displayName: 'Tegretol (Carbamazepine)', value: 'Carbamazepine' },
      { displayName: 'Gabapentin', value: 'Gabapentin' },
      { displayName: 'Clonazepam', value: 'Clonazepam' },
      { displayName: 'Bupropion', value: 'Bupropion' },
    ],
    therapeuticAreas: [TherapeuticArea.Neurology],
  },
  {
    conditions: ['psoriatic arthritis'],
    medications: [
      { displayName: 'Humira (Adalimumab)', value: 'Adalimumab' },
      { displayName: 'Cosentyx (Secukinumab)', value: 'Secukinumab' },
      { displayName: 'Stelara (Ustekinumab)', value: 'Ustekinumab' },
      { displayName: 'Rinvoq (Upadacitinib)', value: 'Upadacitinib' },
      { displayName: 'Taltz (Ixekizumab)', value: 'Ixekizumab' },
      { displayName: 'Cyclophosphamide', value: 'Cyclophosphamide' },
      { displayName: 'Azathioprine', value: 'Azathioprine' },
      { displayName: 'Cyclosporine', value: 'Cyclosporine' },
      { displayName: 'Tacrolimus', value: 'Tacrolimus' },
      { displayName: 'Otezla (Apremilast)', value: 'Apremilast' },
      { displayName: 'Enbrel (Etanercept)', value: 'Etanercept' },
    ],
    therapeuticAreas: [TherapeuticArea.Rheumatology],
  },
  {
    conditions: ['plaque psoriasis'],
    medications: [
      { displayName: 'Trexall (Methotrexate)', value: 'Methotrexate' },
      { displayName: 'Otezla (Apremilast)', value: 'Apremilast' },
      { displayName: 'Soriatane (Acitretin)', value: 'Acitretin' },
      { displayName: 'Neotigason (Acitretin)', value: 'Acitretin' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Gengraf (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Humira (Adalimumab)', value: 'Adalimumab' },
      { displayName: 'Stelara (Ustekinumab)', value: 'Ustekinumab' },
      { displayName: 'Enbrel (Etanercept)', value: 'Etanercept' },
    ],
    therapeuticAreas: [TherapeuticArea.Dermatology],
  },
  {
    conditions: ['osteoarthritis'],
    medications: [
      { displayName: 'Mobic (Meloxicam)', value: 'Meloxicam' },
      { displayName: 'Celebrex (Celecoxib)', value: 'Celecoxib' },
      { displayName: 'Synvisc (Hylan G-F 20)', value: 'Hylan G-F 20' },
      { displayName: 'Kenalog (Triamcinolone)', value: 'Triamcinolone' },
      { displayName: 'Ultram (Tramadol)', value: 'Tramadol' },
      { displayName: 'Lyrica (Pregabalin)', value: 'Pregabalin' },
      { displayName: 'OxyContin (Oxycodone)', value: 'Oxycodone' },
      { displayName: 'Vicodin (Hydrocodone)', value: 'Hydrocodone' },
      { displayName: 'Humira (Adalimumab)', value: 'Adalimumab' },
    ],
    therapeuticAreas: [TherapeuticArea.Orthopedics],
  },
  {
    conditions: ['myasthenia gravis'],
    medications: [
      { displayName: 'Soliris (Eculizumab)', value: 'Eculizumab' },
      { displayName: 'Ultomiris (Ravulizumab)', value: 'Ravulizumab' },
      {
        displayName: 'Vyvgart (Efgartigimod-alfa)',
        value: 'Efgartigimod-alfa',
      },
      {
        displayName: 'Rystiggo (Rozanolixizumab-noli)',
        value: 'Rozanolixizumab-noli',
      },
      { displayName: 'Zilbrysq (Zilucoplan)', value: 'Zilucoplan' },
      { displayName: 'Rituxan (Rituximab)', value: 'Rituximab' },
    ],
    therapeuticAreas: [TherapeuticArea.Neurology],
  },
  {
    conditions: ['stargardt disease'],
    medications: [
      { displayName: 'Accutane (Isotretinoin)', value: 'Isotretinoin' },
      { displayName: 'Soriatane (Acitretin)', value: 'Acitretin' },
      { displayName: 'High-dose Vitamin A', value: 'Vitamin A (High Dose)' },
      {
        displayName: 'Plaquenil (Hydroxychloroquine)',
        value: 'Hydroxychloroquine',
      },
      { displayName: 'Aralen (Chloroquine)', value: 'Chloroquine' },
      { displayName: 'Nolvadex (Tamoxifen)', value: 'Tamoxifen' },
      { displayName: 'Lucentis (Ranibizumab)', value: 'Ranibizumab' },
      { displayName: 'Eylea (Aflibercept)', value: 'Aflibercept' },
    ],
    therapeuticAreas: [TherapeuticArea.Ophthalmology],
  },
  {
    conditions: ['rheumatoid arthritis'],
    medications: [
      { displayName: 'Rituxan (Rituximab)', value: 'Rituximab' },
      { displayName: 'Orencia (Abatacept)', value: 'Abatacept' },
      { displayName: 'Humira (Adalimumab)', value: 'Adalimumab' },
      { displayName: 'Enbrel (Etanercept)', value: 'Etanercept' },
      { displayName: 'Remicade (Infliximab)', value: 'Infliximab' },
      {
        displayName: 'Cimzia (Certolizumab pegol)',
        value: 'Certolizumab pegol',
      },
      { displayName: 'Simponi (Golimumab)', value: 'Golimumab' },
      { displayName: 'Actemra (Tocilizumab)', value: 'Tocilizumab' },
      { displayName: 'Kevzara (Sarilumab)', value: 'Sarilumab' },
    ],
    therapeuticAreas: [TherapeuticArea.Rheumatology],
  },
  {
    conditions: ['ulcerative colitis'],
    medications: [
      { displayName: 'Remicade (Infliximab)', value: 'Infliximab' },
      { displayName: 'Humira (Adalimumab)', value: 'Adalimumab' },
      { displayName: 'Entyvio (Vedolizumab)', value: 'Vedolizumab' },
      { displayName: 'Stelara (Ustekinumab)', value: 'Ustekinumab' },
      { displayName: 'Xeljanz (Tofacitinib)', value: 'Tofacitinib' },
      { displayName: 'Rinvoq (Upadacitinib)', value: 'Upadacitinib' },
      { displayName: 'Zeposia (Ozanimod)', value: 'Ozanimod' },
      { displayName: 'Neoral (Cyclosporine)', value: 'Cyclosporine' },
      { displayName: 'Prograf (Tacrolimus)', value: 'Tacrolimus' },
      { displayName: 'Trexall (Methotrexate)', value: 'Methotrexate' },
    ],
    therapeuticAreas: [TherapeuticArea.Gastroenterology],
  },
  {
    conditions: ['dry eye'],
    medications: [
      { displayName: 'Restasis (Cyclosporine A)', value: 'Cyclosporine A' },
      { displayName: 'Xiidra (Lifitegrast)', value: 'Lifitegrast' },
      { displayName: 'Cequa (Cyclosporine A)', value: 'Cyclosporine A' },
      {
        displayName: 'Eysuvis (Loteprednol Etabonate)',
        value: 'Loteprednol Etabonate',
      },
      {
        displayName: 'Pred Forte (Prednisolone Acetate)',
        value: 'Prednisolone Acetate',
      },
      { displayName: 'Tyrvaya (Varenicline)', value: 'Varenicline' },
      { displayName: 'Accutane (Isotretinoin)', value: 'Isotretinoin' },
      { displayName: 'Claritin (Loratadine)', value: 'Loratadine' },
      { displayName: 'Elavil (Amitriptyline)', value: 'Amitriptyline' },
      { displayName: 'Xalatan (Latanoprost)', value: 'Latanoprost' },
    ],
    therapeuticAreas: [TherapeuticArea.Ophthalmology],
  },
  {
    conditions: ['diabetes'],
    medications: [
      { displayName: 'Lantus (Insulin Glargine)', value: 'Insulin Glargine' },
      { displayName: 'Basaglar (Insulin Glargine)', value: 'Insulin Glargine' },
      { displayName: 'Ozempic (Semaglutide)', value: 'Semaglutide' },
      { displayName: 'Rybelsus (Semaglutide)', value: 'Semaglutide' },
      { displayName: 'Trulicity (Dulaglutide)', value: 'Dulaglutide' },
      { displayName: 'Jardiance (Empagliflozin)', value: 'Empagliflozin' },
      { displayName: 'Farxiga (Dapagliflozin)', value: 'Dapagliflozin' },
      { displayName: 'Prednisone (Prednisone)', value: 'Prednisone' },
      { displayName: 'Wegovy (Semaglutide)', value: 'Semaglutide' },
    ],
    therapeuticAreas: [TherapeuticArea.MetabolismAndEndocrinology],
  },
  {
    conditions: ['obesity'],
    medications: [
      { displayName: 'Wegovy (Semaglutide)', value: 'Semaglutide' },
      { displayName: 'Saxenda (Liraglutide)', value: 'Liraglutide' },
      { displayName: 'Zepbound (Tirzepatide)', value: 'Tirzepatide' },
      {
        displayName: 'Qsymia (Phentermine/Topiramate)',
        value: 'Phentermine/Topiramate',
      },
      { displayName: 'Mounjaro (Tirzepatide)', value: 'Tirzepatide' },
      {
        displayName: 'Contrave (Bupropion/Naltrexone)',
        value: 'Bupropion/Naltrexone',
      },
      { displayName: 'Orlistat', value: 'Orlistat' },
      { displayName: 'Adipex-P (Phentermine)', value: 'Phentermine' },
      { displayName: 'Topamax (Topiramate)', value: 'Topiramate' },
      { displayName: 'Deltasone (Prednisone)', value: 'Prednisone' },
      { displayName: 'Zyprexa (Olanzapine)', value: 'Olanzapine' },
    ],
    therapeuticAreas: [
      TherapeuticArea.Gastroenterology,
      TherapeuticArea.MetabolismAndEndocrinology,
    ],
  },
  {
    conditions: ['hypertension'],
    medications: [
      { displayName: 'Aldactone (Spironolactone)', value: 'Spironolactone' },
      { displayName: 'Inspra (Eplerenone)', value: 'Eplerenone' },
      { displayName: 'Kerendia (Finerenone)', value: 'Finerenone' },
      { displayName: 'Tekturna (Aliskiren)', value: 'Aliskiren' },
      { displayName: 'Nizoral (Ketoconazole)', value: 'Ketoconazole' },
      { displayName: 'Biaxin (Clarithromycin)', value: 'Clarithromycin' },
      { displayName: 'Norvir (Ritonavir)', value: 'Ritonavir' },
      { displayName: 'Sporanox (Itraconazole)', value: 'Itraconazole' },
      { displayName: 'Lithium', value: 'Lithium' },
      { displayName: 'Lanoxin (Digoxin)', value: 'Digoxin' },
    ],
    therapeuticAreas: [TherapeuticArea.Cardiology],
  },
  {
    conditions: ['default'],
    medications: [
      { displayName: 'Sertraline (Zoloft)', value: 'Sertraline' },
      { displayName: 'Fluoxetine (Prozac)', value: 'Fluoxetine' },
      { displayName: 'Escitalopram (Lexapro)', value: 'Escitalopram' },
      { displayName: 'Venlafaxine (Effexor)', value: 'Venlafaxine' },
      { displayName: 'Quetiapine (Seroquel)', value: 'Quetiapine' },
      { displayName: 'Aripiprazole (Abilify)', value: 'Aripiprazole' },
      { displayName: 'Risperidone (Risperdal)', value: 'Risperidone' },
      { displayName: 'Lithium (Lithobid)', value: 'Lithium' },
      { displayName: 'Clonazepam (Klonopin)', value: 'Clonazepam' },
      { displayName: 'Buspirone (BuSpar)', value: 'Buspirone' },
    ],
    therapeuticAreas: [TherapeuticArea.Psychiatry],
  },
]

export const DefaultPopularMedications: Medication[] = [
  { displayName: 'Acetaminophen', value: 'Acetaminophen' },
  { displayName: 'Albuterol', value: 'Albuterol' },
  { displayName: 'Amlodipine', value: 'Amlodipine' },
  { displayName: 'Atorvastatin', value: 'Atorvastatin' },
  { displayName: 'Levothyroxine', value: 'Levothyroxine' },
  { displayName: 'Lisinopril', value: 'Lisinopril' },
  { displayName: 'Metformin', value: 'Metformin' },
  { displayName: 'Metoprolol', value: 'Metoprolol' },
  { displayName: 'Omeprazole', value: 'Omeprazole' },
  { displayName: 'Simvastatin', value: 'Simvastatin' },
]
